export default __webpack_public_path__ + "static/media/icon_01_websites.146b9107.svg";